// @flow

// Vendors
import React, { useState } from 'react';

// Components
import ProductsFilters from './ProductsFilters';
import ProductsGrid from './ProductsGrid';
import ProductsEmpty from './ProductsEmpty';

const Products = () => {
  const { markets, solutions, products } = window.products_filter_data;
  const initialValues = {
    market: '',
    solution: ''
  };
  const [values, setValues] = useState(initialValues);

  const productMatchesMarket = (market, product) =>
    market
      ? (product.meta.related_market || []).includes(Number(market))
      : true;

  const productMatchesSolution = (solution, product) =>
    solution
      ? (product.meta.related_solution || []).includes(Number(solution))
      : true;

  const filteredProducts = products.filter(
    product =>
      productMatchesMarket(values.market, product) &&
      productMatchesSolution(values.solution, product)
  );

  const handleInputChange = event =>
    setValues({ ...values, [event.target.name]: event.target.value });

  const clearFilters = () => setValues(initialValues);
  const clearFilter = fieldName => setValues({ ...values, [fieldName]: '' });

  return (
    <div className="container">
      <ProductsFilters
        values={values}
        clearFilter={clearFilter}
        handleInputChange={handleInputChange}
        markets={markets}
        solutions={solutions}
      />
      {filteredProducts.length > 0 && (
        <ProductsGrid products={filteredProducts} />
      )}
      {filteredProducts.length < 1 && (
        <ProductsEmpty clearFilters={clearFilters} />
      )}
    </div>
  );
};

export default Products;
